<template lang="pug">
.subscribe-modal
  y-dialog(v-model="dialog" persistent scrollable :fullscreen="$vuetify.breakpoint.xsOnly" max-width="600px")
    v-card(min-height="80vh")
      v-card-title.px-4
        v-layout
          eva-icon.mr-4(name="close-outline" :fill="$vuetify.theme.themes[$theme].primary500" @click="dialog = false")
          .h6.textColor--text Multi Branch Subscription
      v-card-text.px-4
        y-stepper.mb-8(v-if="step < 4" :currentStep="step" :steps="steps")
        v-window(v-model="step" touchless)
          v-window-item(:value="0")
            //- =========================================================================================================
            //-  1. Choose your plan
            //- =========================================================================================================
            v-layout.pa-6(v-if="isFetchingPlanGroup")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            .contracts(v-else)
              v-card.pa-4.mb-4(outlined v-for="(contract, index) in contracts" :ripple="false" :key="contract.code" :style="contract.selected ? 'border:2px solid var(--v-textColorAccent)' : 'border:2px solid var(--v-basic300)'" :color="currentContract(contract) ? $vuetify.theme.themes[$theme].dangerT08: $vuetify.theme.themes[$theme].basic600T08")
                div(@click="selectContract(contract)")
                  div.d-flex.align-center
                    div.h5.textColor--text {{ contract.data.extra_data[planVersion].name }}
                    div.ml-2(v-if="contract.selected" )
                      v-avatar.my-auto(:color='$vuetify.theme.themes[$theme].textColorAccent' size=20)
                        eva-icon(name="checkmark-outline" :fill="$vuetify.theme.themes[$theme].basic100" width="18" height="18" style="margin-top:3px; margin-left: 1px;")
                    v-spacer
                    div.h4.textColor--text.text-right(style="") {{ contract.data.original_price/100 }}
                  div.danger500--text(v-if="currentContract(contract)") (Current Plan)
                  div.d-flex.mt-3
                    div
                      .s1.success500--text(v-if="contract.data.extra_data[planVersion].recommended") Recommended for you!
                      .p1.primary500--text {{ contract.data.extra_data[planVersion].promo_text }}
                    v-spacer
                    div.p2.primary400--text.text-right(style="margin-top: 2px;") {{ contract.data.extra_data[planVersion].bill_line_1 }}

          v-window-item(:value="1")
            //- =========================================================================================================
            //-  2. Select payment method
            //- =========================================================================================================
            .h5.textColor--text.text-center Select payment method
            v-card.mt-8(flat outlined style="border:1px solid var(--v-basic300);")
              v-radio-group.mt-n1(v-model="selectedPaymentMethod" hide-details)
                v-layout(style="cursor: pointer" @click="selectedPaymentMethod = 'card'")
                  v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                    eva-icon.ma-auto(name="credit-card-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                  v-col.pa-0.my-auto
                    v-layout.py-4
                      div.my-auto.pr-2
                        .s1.basic800--text Credit or debit card
                  v-col.pa-0.shrink.mt-5
                    v-radio.my-0.py-0.mr-2(value="card" readonly)
                v-divider.basic300
                template(v-if="selectedContract")
                  v-layout(:style="selectedContract.data.billing_cycle === 'monthly' ? 'cursor: default' : 'cursor: pointer'" @click="selectedContract.data.billing_cycle === 'monthly' ? '' : selectedPaymentMethod = 'fpx'")
                    v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                      BuildingBankIcon.ma-auto(size="24" :style="selectedContract.data.billing_cycle === 'yearly' ? 'color: var(--v-basic700)' : 'color: var(--v-basic500)'")
                    v-col.pa-0.my-auto
                      v-layout.py-4
                        div.my-auto.pr-2
                          .s1(:class="selectedContract.data.billing_cycle === 'yearly' ? 'basic800--text' : 'basic500--text' ") Online banking
                          .c1.basic500--text(v-if="selectedContract.data.billing_cycle === 'monthly'") For yearly contract only
                    v-col.pa-0.shrink.mt-5
                      v-radio.my-0.py-0.mr-2(value="fpx" readonly)

            v-card.pa-4.mt-8(v-if="selectedPaymentMethod" flat outlined style="border:1px solid var(--v-basic300);")
              card-list.mt-4(v-if="selectedPaymentMethod === 'card'" @change="form.card = $event.id")
              .online-payment.mt-4(v-else-if="selectedPaymentMethod === 'fpx'" )
                div.subtitle.mb-3 Choose bank for payment
                v-card.mb-12
                  FPXPicker(v-model="fpxBankCode")
          v-window-item.text-center(v-if="selectedContract" :value="2")
            //- =========================================================================================================
            //-  3. Confirm your subscription
            //- =========================================================================================================
            v-layout.pa-6(v-if="isFetchingQuotation")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            template(v-else-if="quotation")
              template(v-if="quotation.void")
                .h6.mt-12.danger500--text {{ $t('no_change_subscription') }}
              template(v-else-if="hasPendingBills")
                .h3.mt-12.danger500--text {{ $t('pending_payment') }}
                .h6.mt-6.textColor--text {{ $tc('you_have', quotation.pending_bills.length, { count: quotation.pending_bills.length }) }} {{ $t('please_take') }}
                v-btn.mt-4(color="danger500" dark @click="clickPayBill" depressed height=32 )
                  .button-AA-medium.basic100--text {{ $t('pay_now') }}
              template(v-else)
                .h5.textColor--text.text-center.mb-8 Confirm your subscription
                .h3.mt-6.textColor--text Clinic {{ selectedContract.data.billing_cycle | capitalize }}
                .extra(v-if="addOn.selected" v-for="(addOn, index) in selectedContract.data.add_ons" :key="'confirmation' + addOn.id")
                  .s1.textColor--text + {{ addOn.feature.name }}
                .h1.text-center.my-8 {{ quotation.total_amount | displayPrice($currency) }}
                .s1.primary500--text {{ $t('next_billing_amount', { amount: $options.filters.displayPriceRM(quotation.next_bill_amount) }) }}
                .s1.primary500--text {{ $t('next_billing_date', { date: $options.filters.displayDate(quotation.end_date) }) }}

          v-window-item(:value="3")
            //- =========================================================================================================
            //-  4. Thank you
            //- =========================================================================================================
            .h5.textColor--text.mb-8.text-center Subscription successful!
            v-container.text-center
              .p1.primary400--text Thank you for giving us the opportunity to help you grow further and bigger.
              .p1.primary400--text.mt-4 Let’s do this together.
              v-btn.mt-4(color="info500" dark @click="dialog = false; $emit('setgene')" depressed height=32 )
                .button-AA-medium.basic100--text FINISH
          v-window-item(:value="4")
            //- =========================================================================================================
            //-  4. Payment failed
            //- =========================================================================================================
            .h5.textColor--text.mb-8.text-center Payment failed
            v-container.text-center
              .p1.primary400--text The payment did not go through, please try again.
              v-btn.mt-4(color="info500" dark @click="retryPayment" depressed height=32 )
                .button-AA-medium.basic100--text Retry Payment

      v-divider.basic300(v-if="step == 0")
      v-card-actions.basic200.px-4(v-if="step == 0 && selectedContract")
        v-col.pa-0
          .s2.primary400--text Selected plan:
          v-layout
            .p2.textColor--text {{ selectedContract.data.billing_cycle | capitalize }} contract
            v-spacer
            .p2.textColor--text {{ selectedContract.data.price | displayPriceRM }}
          v-layout(v-if="addOn.selected" v-for="(addOn, index) in selectedContract.data.add_ons" :key="'selected' + addOn.id")
            .p2.textColor--text + {{ addOn.feature.name }}
            v-spacer
            .p2.textColor--text {{ addOn.price | displayPriceRM }}
      v-divider.basic400(v-if="step == 0")
      v-card-actions.pr-4(:class="step == 0 ? 'basic200' : ''" v-if="steps[step].primaryButton")
        v-spacer
        v-btn(color='white' text @click="previousStep")
          .button-Aa-medium.primary400--text {{ steps[step].secondaryButton }}
        v-btn(v-if="step == 1" color="info500" @click="nextStep" depressed height=40 :disabled="!fpxBankCode && !form.card")
          .button-AA-medium.basic100--text {{ steps[step].primaryButton }}
        v-btn(v-else-if="step == 2" color="info500" @click="nextStep" depressed height=40 :loading="isLoading" :dark="!disableProceedPayment" :disabled="disableProceedPayment")
          .button-AA-medium.basic100--text {{ steps[step].primaryButton }}
        v-btn(v-else color="info500" @click="nextStep" depressed height=40 :loading="isLoading" dark)
          .button-AA-medium.basic100--text {{ steps[step].primaryButton }}

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { setOptions, bootstrap } from 'vue-gtag'
import CardList from '@/components/billing/CardList.vue'
import FPXPicker from '@/components/FPXPicker.vue'
import Cookies from 'js-cookie'

export default {
  name: "EditSubscriptionMultibranchModal",
  components: { CardList, FPXPicker },
  props: ['open', 'company', 'paymentCallback'],
  data: (v) => ({
    isFetchingPlanGroup: false,
    isFetchingQuotation: false,
    step: 0,
    planGroup: null,
    planVersion: 'v1.0',
    contracts: [],
    selectedContract: null,
    form: {
      company: v.company.id,
      contract: null,
      card: null
    },
    isLoading: false,
    selectedPaymentMethod: null,
    fpxBankCode: null,
    retryPaymentLoading: false,
    quotation: null,
    statistics: {
      sales: 0,
      potential_sales: 0,
      total_expenses: 0,
      biggest_expense_category: null,
      biggest_expense_amount: 0,
    },
    steps: [
      { title: 'Select plan', hidden: false, secondaryButton: 'Back', primaryButton: 'Next' },
      { title: 'Payment', hidden: false, secondaryButton: 'Back', primaryButton: 'Next' },
      { title: 'Confirmation', hidden: false, secondaryButton: 'Back', primaryButton: 'confirm' },
      { title: 'Subscription Successful!', hidden: true, primaryButton: null },
      { title: 'Payment Unsuccessful', hidden: true, primaryButton: null }
    ]
  }),
  computed: {
    ...mapState('subscriptions', ['multiBranchSubscription', 'genesData']),
    authMember () {
      return this.$store.state.user.member
    },
    dialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    // subscribedAddons () {
    //   let reminders = this.genesData.find(f => f.feature === 'YBOOKS_REMINDER')
    //   let addons = {}
    //   if (reminders) {
    //     addons.reminders = reminders.data
    //   }
    //   return addons
    // },
    hasPendingBills () {
      if (this.quotation && this.quotation.pending_bills.length > 0) {
        return true
      }
      return false
    },
    disableProceedPayment () {
      if (!this.quotation) {
        return true
      }
      if (this.hasPendingBills) {
        return true
      }
      return false
    }
  },
  watch: {
    selectedContract (val) {
      if (val.data.billing_cycle === 'monthly' && this.selectedPaymentMethod == 'fpx') {
        this.selectedPaymentMethod = 'card'
      }
    }
  },
  mounted () {
    this.fetchCompany()
    this.fetchPlanGroup()

    if (this.paymentCallback) {
      if (this.paymentCallback.success) {
        this.step = 4
      } else {
        this.step = 5
      }
    }

    this.$axios.get(`/books/${this.company.slug}/statistics`)
      .then(resp => {
        this.statistics = resp.data
      })
      .catch(() => {})
  },
  methods: {
    ...mapActions([
      'showMessage',
      'updateCompany'
    ]),
    fetchCompany () {
      this.$axios.get(`/companies/${this.company.id}/`)
        .then(resp => {
          this.updateCompany(resp.data)
        })
        .catch(() => {})
    },
    fetchPlanGroup () {
      this.isFetchingPlanGroup = true
      this.$axios.get(`/subscription/plan_groups`)
        .then(resp => {
          const groups = resp.data.results
          const multibranchPlans = groups.filter(group => group.code === 'YZ_MULTIBRANCH')
          if (multibranchPlans.length > 0) {
            this.planGroup = multibranchPlans[0]
            const plansStructure = this.planGroup.extra_data[this.planVersion]
            this.contracts = []
            plansStructure.forEach((structure) => {
              console.log({structure})
              this.planGroup.plans.forEach((plan) => {
                console.log({plan})
                plan.contracts.forEach((contract) => {
                  console.log({contract})
                  if (structure.code === contract.code) {
                    const newContract = {
                      selected: false,
                      data: contract
                    }
                    newContract.data.original_price = newContract.data.price
                    this.contracts.push(newContract)
                    console.log({newContract})
                  }
                })
              })
            })
            this.checkCurrentContract()
            // this.contracts[0].selected = true
            // this.selectedContract = this.contracts[0]
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingPlanGroup = false
        })
    },
    fetchQuotation () {
      this.isFetchingQuotation = true
      let data = {
        contract: this.selectedContract.data.code,
        add_ons: []
      }
      this.selectedContract.data.add_ons.forEach(addOns => {
        let item = {
          feature: addOns.feature.code,
          count: 0
        }
        if (addOns.selected) {
          item.count = 1
        }
        data.add_ons.push(item)
      })
      this.$axios.post(`/subscription/subscriptions/${this.multiBranchSubscription.data.id}/quotation`, data)
        .then(resp => {
          this.quotation = resp.data
        })
        .catch(() => {
          this.showMessage(['error', 'Unable to subscribe. Please try again or contact our support team.'])
        })
        .finally(() => {
          this.isFetchingQuotation = false
        })
    },
    selectContract(contract) {
      this.contracts.forEach(c => {
        if (c.data.code === contract.data.code) {
          c.selected = true
          this.selectedContract = c
        } else {
          c.selected = false
        }
      })
    },
    previousStep () {
      if (this.step === 0) {
        this.dialog = false
      } else {
        this.step--
      }
    },
    nextStep () {
      if (this.step === this.steps.length - 1) return

      if (this.step === 1) {
        if (!this.selectedPaymentMethod) {
          this.showMessage(['error', 'Please select payment method'])
          return
        }
      }

      if (this.step === 1) {
        this.fetchQuotation()
      }

      if (this.step === 2) {
        this.isLoading = true
        this.$axios.post(`/subscription/subscriptions/${this.multiBranchSubscription.data.id}/change`, this.quotation)
          .then(resp => {
            if (this.selectedPaymentMethod === 'card') {
              this.subscribeByCard(resp.data)
            } else if (this.selectedPaymentMethod === 'fpx') {
              this.subscribeByFpx(resp.data)
            }
          })
          .catch(() => {
            this.showMessage(['error', 'Unable to subscribe. Please try different card or contact our support team.'])
            this.isLoading = false
          })
      } else {
        this.step++
      }
    },
    subscribeByCard (data) {
      this.isLoading = true
      this.form.contracts = this.quotation.contracts
      this.form.add_ons = this.quotation.add_ons
      this.form.fbq = {
        cookies: Cookies.get(),
        user_agent: navigator.userAgent
      }
      this.$axios.post(`/subscription/bills/${data.bill}/charge_card/`, this.form)
        .then(() => {
          this.$emit('subscribed')
          this.fetchCompany()
          this.step++
          this.trackPixel()
          this.trackPixelBooks()
          this.trackGtag()
        })
        .catch(() => {
          this.showMessage(['error', 'Unable to subscribe. Please try different card or contact our support team.'])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    subscribeByFpx (data) {
      this.isLoading = true
      this.form.contracts = this.quotation.contracts
      this.form.add_ons = this.quotation.add_ons
      if (this.company.currency.currency_code === 'IDR') {
        this.form.method = 'xendit'
      } else {
        this.form.method = 'laravel'
      }
      this.form.bank_code = this.fpxBankCode
      this.form.fbq = {
        cookies: Cookies.get(),
        user_agent: navigator.userAgent
      }
      if (this.quotation.total_amount > 0) {
        this.$axios.post(`/subscription/bills/${data.bill}/request_manual_payment/`, this.form)
          .then(resp => {
            const data = resp.data
            setTimeout(() => {
              location.href = data.bill_url
            }, 1000)
          })
          .catch(() => {
            this.showMessage(['error', 'Unable to subscribe. Please try different method or contact our support team.'])
            this.isLoading = false
          })
      } else {
        this.$emit('subscribed')
        this.fetchCompany()
        this.isLoading = false
        this.step++
      }
    },
    retryPayment () {
      this.retryPaymentLoading = true
      location.href = `${process.env.VUE_APP_BILLPLZ_URL}/bills/${this.paymentCallback.billId}?auto_submit=true`
    },
    trackGtag () {
      setOptions({
        config: { id: process.env.VUE_APP_YEZZA_GTAG_ID }
      })
      bootstrap().then(() => {
        this.$gtag.linker({
          'domains': ['yezza.com', 'yezza.io']
        })
        this.$gtag.purchase({
          'value': this.quotation.total_amount
        })
      })
    },
    trackPixel () {
      // Submit to Yezza pixel
      window.fbq('trackSingle', process.env.VUE_APP_YEZZA_FB_PIXEL_ID, 'Subscribe', {
        value: this.quotation.total_amount/100,
        currency: 'MYR'
      })
    },
    trackPixelBooks () {
      // Submit to YezzaBooks pixel
      window.fbq('trackSingle', process.env.VUE_APP_YEZZABOOKS_FB_PIXEL_ID, 'Subscribe', {
        value: this.quotation.total_amount/100,
        currency: 'MYR'
      })
    },
    checkCurrentContract () {
      this.contracts.forEach(contract => {
        if (this.currentContract(contract)) {
          this.selectContract(contract)
        }
      })
      // this.checkAddons()
    },
    currentContract (contract) {
      if (this.multiBranchSubscription.data.contract.code === contract.data.code) {
        return true
      }
      return false
    },
    // checkAddons () {
    //   if (this.multiBranchSubscription.data.add_ons && this.multiBranchSubscription.data.add_ons.length > 0) {
    //     let reminderAddons = this.multiBranchSubscription.data.add_ons.find(f => f.add_on.feature.code === 'YBOOKS_REMINDER')
    //     let check = this.selectedContract.data.add_ons.find(f => f.feature.code === 'YBOOKS_REMINDER')
    //     if (reminderAddons && check) {
    //       check['selected'] = true
    //     }
    //   }
    // },
    clickPayBill () {
      if (this.quotation.pending_bills.length > 0) {
        this.$router.push(`/admin/billing/bills/${this.quotation.pending_bills[0]}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.colbox {
  border: 1px solid var(--v-primary400);
  background-color: var(--v-basic200);
  border-radius: 5px;
  text-align: center;
  padding-top: 3px;
  margin-left: 4px;
  margin-right: 4px;
  height: 32px;
  width: 60px;
}

.v-card.payment-method-selected {
  border-color: #D11184;
}

.separator {
  position: absolute;
  height:2px;
  top: 38px;
  left: 0px;
  right: 0px;
}
</style>

<i18n>
{
  "en": {
    "reminder_addons": "+ reminder (active until {date})",
    "next_billing_amount": "Next billing amount: {amount}",
    "next_billing_date": "Next billing date: {date}",
    "you_have": "You have {count} pending payment. | You have {count} pending payments.",
    "please_take": "Please take care of any outstanding payments before changing subscription."
  },
  "id": {
    "reminder_addons": "+ pengingat (aktif hingga {date})",
    "next_billing_amount": "Next billing amount: {amount}",
    "next_billing_date": "Tanggal tagihan berikutnya: {date}",
    "you_have": "Anda memiliki {count} pembayaran yang tertunda. | kamu memiliki {count} pembayaran yang tertunda.",
    "please_take": "Harap urus semua pembayaran terutang sebelum mengubah langganan."
  }
}
</i18n>
